import { useGetOne } from 'react-admin';

export const DASHBOARD_QUERY = 'claims';

export function useDashboard() {
  return useGetOne(DASHBOARD_QUERY, { id: 'self' });
}
